module.exports = __webpack_public_path__ + "img/生态基地3.7ad2ee17.jpg";